<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div v-for="(stat, key) in stats" :key="key" class="col-lg-4 col-md-4 col-12">
            <card
              :title="stat.title"
              :value="stat.value"
              :iconClass="stat.iconClass"
              :iconBackground="stat.iconBackground"
              directionReverse
            ></card>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-6 mb-lg-0 mb-4">
            <div class="card shadow-sm">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-2">Monitoreo GPS en Tiempo Real</h6>
              </div>
              <div id="map-container" class="map-container" style="height: 450px; z-index: 1;"></div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card shadow-sm" style="height: 450px; overflow-y: auto;">
              <div class="card-header pb-0 text-start">
                <h6>Asistencia y Productividad Diaria</h6>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Empleado</th>
                      <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Entrada / Salida</th>
                      <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Horas</th>
                      <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Tareas (Ok/Total)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in attendanceData" :key="index">
                      <td class="ps-4">
                        <h6 class="mb-0 text-sm">{{ row.user_name }}</h6>
                      </td>
                      <td class="text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                           <i class="fa fa-sign-in-alt text-success me-1"></i> {{ formatTime(row.clock_in) }}
                        </span>
                        <br>
                        <span class="text-secondary text-xs font-weight-bold">
                           <i class="fa fa-sign-out-alt text-danger me-1"></i> {{ formatTime(row.clock_out) }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span class="badge badge-sm bg-gradient-dark">{{ row.total_hours || '0.00' }} h</span>
                      </td>
                      <td class="align-middle text-center">
                        <div class="d-flex align-items-center justify-content-center">
                          <span class="me-2 text-xs font-weight-bold">{{ row.tasks_completed }}/{{ row.tasks_assigned }}</span>
                          <div class="progress" style="width: 50px; height: 6px;">
                            <div
                              class="progress-bar bg-gradient-info"
                              role="progressbar"
                              :style="{ width: (row.tasks_assigned > 0 ? (row.tasks_completed / row.tasks_assigned * 100) : 0) + '%' }">
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-6">
            <div class="card shadow-sm">
              <div class="card-header pb-0 text-start">
                <h6>Productividad: Asignadas vs Completadas</h6>
              </div>
              <div class="card-body p-3">
                <bar-chart id="prod-chart" :chart="productivityChartData" />
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card shadow-sm">
              <div class="card-header pb-0 text-start">
                <h6>Recuperación: Proyectado vs Cobrado ($)</h6>
              </div>
              <div class="card-body p-3">
                <bar-chart id="collection-chart" :chart="collectionChartData" />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <div class="card">
              <div class="card-header pb-0">
                <h6>Estado Actual del Personal</h6>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-4">Usuario</th>
                      <th class="text-center text-uppercase text-dark text-xxs font-weight-bolder opacity-7">Tareas (Ok/Total)</th>
                      <th class="text-center text-uppercase text-dark text-xxs font-weight-bolder opacity-7">Recuperación (Recuperado/Proyectado)</th>
                      <th class="text-center text-uppercase text-dark text-xxs font-weight-bolder opacity-7">Última Ubicación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in employeeTaskData" :key="index">
                      <td class="ps-4">
                        <div class="d-flex flex-column">
                          <h6 class="mb-0 text-sm">{{ user.user_name }}</h6>
                          <p class="text-xs text-secondary mb-0">@{{ user.user_username }}</p>
                        </div>
                      </td>
                      <td class="text-center text-sm font-weight-bold">
                        {{ user.total_completed }} / {{ user.total_assigned }}
                      </td>
                      <td class="text-center text-sm text-secondary font-weight-bold">
                        $ {{ parseFloat(user.total_collected || 0).toFixed(2) }} / $ {{ parseFloat(user.total_to_collect || 0).toFixed(2) }}
                      </td>
                      <td class="text-center">
                        <span class="text-xs font-weight-bold text-info">
                          <i class="fa fa-map-marker-alt me-1"></i>
                          {{ user.last_seen ? formatDateTime(user.last_seen) : 'Sin reporte' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4" v-for="(data, branchName) in branchTotals" :key="branchName">
          <div class="col-12">
            <div class="card shadow-sm mb-4">
              <div class="card-header bg-success p-2 text-center">
                <h6 class="text-white mb-0 text-uppercase">AGENCIA {{ branchName }}</h6>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered align-items-center mb-0 text-center">
                  <thead class="bg-dark">
                    <tr>
                      <th rowspan="2" class="text-uppercase text-xxs font-weight-bolder text-white">Asesor</th>
                      <th colspan="3" class="text-uppercase text-xxs font-weight-bolder text-white">Cliente (Tareas)</th>
                      <th colspan="3" class="text-uppercase text-xxs font-weight-bolder text-white">Efectivo (Cobros)</th>
                    </tr>
                    <tr>
                      <th class="text-uppercase text-xxs font-weight-bolder text-white">Asignadas</th>
                      <th class="text-uppercase text-xxs font-weight-bolder text-white">Realizadas</th>
                      <th class="text-uppercase text-xxs font-weight-bolder text-white">%</th>
                      <th class="text-uppercase text-xxs font-weight-bolder text-white">Proyectado</th>
                      <th class="text-uppercase text-xxs font-weight-bolder text-white">Realizado</th>
                      <th class="text-uppercase text-xxs font-weight-bolder text-white">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in branchPerformanceData.filter(u => u.branch_name === branchName)" :key="user.employee_username">
                      <td class="text-sm font-weight-bold text-start">{{ user.employee_name }}</td>
                      <td class="text-sm">{{ user.total_assigned }}</td>
                      <td class="text-sm">{{ user.total_completed }}</td>
                      <td class="text-sm font-weight-bold bg-light">{{ user.compliance_rate }}%</td>
                      <td class="text-sm text-end">$ {{ parseFloat(user.assigned_amount).toFixed(2) }}</td>
                      <td class="text-sm text-end">$ {{ parseFloat(user.realized_amount).toFixed(2) }}</td>
                      <td class="text-sm font-weight-bold bg-light">{{ user.collection_rate }}%</td>
                    </tr>
                  </tbody>
                  <tfoot class="bg-gradient-success text-white font-weight-bold">
                    <tr>
                      <td>TOTAL</td>
                      <td>{{ data.assigned }}</td>
                      <td>{{ data.completed }}</td>
                      <td>{{ ((data.completed / data.assigned) * 100).toFixed(2) }}%</td>
                      <td class=" text-end">$ {{ data.to_collect.toFixed(2) }}</td>
                      <td class=" text-end">$ {{ data.collected.toFixed(2) }}</td>
                      <td>{{ ((data.collected / data.to_collect) * 100).toFixed(2) }}%</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <div class="card bg-success text-white p-3 mt-4" v-if="Object.keys(branchTotals).length > 0">
              <div class="row text-center">
                <div class="col-2 font-weight-bold">GRAN TOTAL</div>
                <div class="col-2">Tareas: {{ grandTotal.assigned }} / {{ grandTotal.completed }}</div>
                <div class="col-3 font-weight-bold text-white">Cumplimiento: {{ grandTotal.taskPercent }}%</div>
                <div class="col-2">Cobros: $ {{ grandTotal.collected.toFixed(2) }}</div>
                <div class="col-3 font-weight-bold text-white">Efectividad: {{ grandTotal.percent }}%</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3 mt-4">
          <div class="col-12 d-flex justify-content-center">
            <button
              @click="handlePrint"
              class="btn btn-danger shadow-sm d-flex align-items-center"
            >
              <i class="fa fa-file-pdf me-2"></i>
              Exportar Reporte PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/examples/Cards/Card.vue";
import BarChart from "@/examples/Charts/BarChart.vue";
import axios from "axios";
import L from 'leaflet';
import moment from "moment";
import { markRaw } from "vue"; // Importante para evitar el error de Leaflet

// Fix Iconos Marcadores
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { useCompanyConfig } from '@/composables/useCompanyConfig';
import { useDashboardPDF } from '@/composables/useDashboardPDF';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });

export default {
  name: "task-tracking-dashboard",
  components: { Card, BarChart },
  setup(){
    const { companyConfig, isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
    fetchCompanyConfig();
    return {
            companyConfig,
            isLoadingCiaConfig,
        };
  },
  data() {
    return {
      employeeTaskData: [],
      attendanceData: [],
      markers: {},
      map: null,
      polling: null,
      productivityChartData: { labels: [], datasets: [] },
      collectionChartData: { labels: [], datasets: [] },
      branchPerformanceData: [],
      stats: {
        assignedTasks: { title: "ASIGNADAS", value: "0", iconClass: "fa fa-list", iconBackground: "bg-primary" },
        completedTasks: { title: "COMPLETADAS", value: "0", iconClass: "fa fa-check", iconBackground: "bg-primary" },
        pendingTasks: { title: "PENDIENTES", value: "0", iconClass: "fa fa-clock", iconBackground: "bg-primary" },
      },
      branchId:parseInt(localStorage.getItem('branchId')),
      userRole:parseInt(localStorage.getItem('userLevel'))
    };
  },
  computed: {
    branchTotals() {
      const groups = {};
      if (!this.branchPerformanceData.length) return {};

      this.branchPerformanceData.forEach(item => {
        const b = item.branch_name || 'Sin Nombre';
        if (!groups[b]) {
          groups[b] = { assigned: 0, completed: 0, to_collect: 0, collected: 0 };
        }
        groups[b].assigned += parseInt(item.total_assigned || 0);
        groups[b].completed += parseInt(item.total_completed || 0);
        groups[b].to_collect += parseFloat(item.assigned_amount || 0);
        groups[b].collected += parseFloat(item.realized_amount || 0);
      });
      return groups;
    },

    grandTotal() {
      let totalAssigned = 0;
      let totalCompleted = 0;
      let totalToCollect = 0;
      let totalCollected = 0;

      const totalsArray = Object.values(this.branchTotals);

      if (totalsArray.length > 0) {
        totalsArray.forEach(b => {
          totalAssigned += b.assigned || 0;
          totalCompleted += b.completed || 0;
          totalToCollect += b.to_collect || 0;
          totalCollected += b.collected || 0;
        });
      }

      return {
        assigned: totalAssigned,
        completed: totalCompleted,
        collected: totalCollected,
        to_collect: totalToCollect,
        // % de cumplimiento de tareas (Clientes)
        taskPercent: totalAssigned > 0 ? ((totalCompleted / totalAssigned) * 100).toFixed(2) : "0.00",
        // % de efectividad de cobro (Efectivo)
        percent: totalToCollect > 0 ? ((totalCollected / totalToCollect) * 100).toFixed(2) : "0.00"
      };
    }
  },
  methods: {
    async fetchDashboardData() {
      const today = moment().format('YYYY-MM-DD');
      const token = localStorage.getItem("accessToken");
      const companyId = localStorage.getItem('companyId');
      let qryParams
      try {
        if(this.userRole==2){
          qryParams= { company_id: companyId, type: 'realtime_monitoring', start_date: today, end_date: today, branch_id:this.branchId}
        }else{
          qryParams= { company_id: companyId, type: 'realtime_monitoring', start_date: today, end_date: today }
        }

        const response = await axios.get(`${this.$store.state.apiURL}reports/tasks`, {
          params:qryParams,
          headers: { 'Authorization': `Bearer ${token}` }
        });

        const realtimeData = response.data || [];
        this.employeeTaskData = realtimeData;

        // --- Gráficos ---
        this.productivityChartData = {
          labels: realtimeData.map(u => u.user_username),
          datasets: [
            {
              label: "Asignadas",
              data: realtimeData.map(u => u.total_assigned),
              backgroundColor: "#FF8000"
            },
            {
              label: "Completadas",
              data: realtimeData.map(u => u.total_completed),
              backgroundColor: "#81C14B"
            }
          ],
          options: {
            plugins: {
              datalabels: {
                anchor: 'end',
                align: 'top',
                color: '#444',
                font: {
                  weight: 'bold',
                  size: 10
                },
                formatter: (value, context) => {
                  // Solo ponemos el % en la barra de "Completadas" (dataset index 1)
                  if (context.datasetIndex === 1) {
                    const assigned = context.chart.data.datasets[0].data[context.dataIndex];
                    const percent = assigned > 0 ? ((value / assigned) * 100).toFixed(0) : 0;
                    return `${value} (${percent}%)`;
                  }
                  return value; // En la de "Asignadas" solo el número
                },
                offset: 4,
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                grace: '15%', // Espacio extra para que no se corten las etiquetas
                ticks: {
                  precision: 0 // Evita decimales en el eje de cantidad de tareas
                }
              }
            }
          }
        };

        this.collectionChartData = {
          labels: realtimeData.map(u => u.user_username),
          datasets: [
            {
              label: "Proyectado $",
              data: realtimeData.map(u => parseFloat(u.total_to_collect || 0)),
              backgroundColor: "#FF8000"
            },
            {
              label: "Recuperado $",
              data: realtimeData.map(u => parseFloat(u.total_collected || 0)),
              backgroundColor: "#81C14B"
            }
          ],
          options: {
            plugins: {
              datalabels: {
                anchor: 'end',
                align: 'top',
                color: '#444',
                font: { weight: 'bold', size: 10 },
                formatter: (value, context) => {
                  // Formateamos el valor actual a moneda (sin decimales para no saturar el gráfico)
                  const formattedValue = '$' + Math.round(value).toLocaleString();

                  // Solo calculamos el % en la barra de "Recuperado $" (dataset index 1)
                  if (context.datasetIndex === 1) {
                    const projected = context.chart.data.datasets[0].data[context.dataIndex];
                    const percent = projected > 0 ? ((value / projected) * 100).toFixed(0) : 0;
                    return `${formattedValue} (${percent}%)`;
                  }

                  return formattedValue;
                },
                offset: 4
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                grace: '20%', // Espacio extra arriba para que no se corten las etiquetas de texto largo
                ticks: {
                  callback: function(value) {
                    return '$' + value.toLocaleString(); // Agrega el signo $ al eje vertical
                  }
                }
              }
            }
          }
        };

        // --- Marcadores Mapa (Validación de existencia del mapa) ---
        if (this.map) {
          realtimeData.forEach(user => {
            if (user.last_lat && user.last_lng) {
              const pos = [user.last_lat, user.last_lng];
              const popupContent = `
                <div class="text-center">
                  <strong>${user.user_name}</strong><br>
                  <span class="text-xs">Visto: ${this.formatDateTime(user.last_seen)}</span><br>
                  <span class="badge bg-primary mt-1">${user.total_completed} / ${user.total_assigned} Tareas</span>
                  <br>
                  <span class="badge bg-secondary mt-1">$${parseFloat(user.total_collected || 0).toFixed(2)} / $${parseFloat(user.total_to_collect || 0).toFixed(2)}</span>
                </div>`;

              if (this.markers[user.user_id]) {
                this.markers[user.user_id].setLatLng(pos).setPopupContent(popupContent);
              } else {
                this.markers[user.user_id] = L.marker(pos).addTo(this.map).bindPopup(popupContent);
              }
            }
          });
        }

        const totalAsig = realtimeData.reduce((acc, u) => acc + parseInt(u.total_assigned || 0), 0);
        const totalComp = realtimeData.reduce((acc, u) => acc + parseInt(u.total_completed || 0), 0);
        this.stats.assignedTasks.value = totalAsig.toString();
        this.stats.completedTasks.value = totalComp.toString();
        this.stats.pendingTasks.value = (totalAsig - totalComp).toString();

      } catch (err) { console.error(err); }
    },

    async fetchAttendanceReport() {
        const today = moment().format('YYYY-MM-DD');
        const token = localStorage.getItem("accessToken");
        const companyId = localStorage.getItem('companyId');
        try {
          let qryParams;
          if(this.userRole==2){
            qryParams= { company_id: companyId, type: 'working_hours', start_date: today, end_date: today , branch_id:this.branchId}
          }else{
            qryParams= { company_id: companyId, type: 'working_hours', start_date: today, end_date: today }
          }
          const response = await axios.get(`${this.$store.state.apiURL}reports/tasks`, {
            params: qryParams,
            headers: { 'Authorization': `Bearer ${token}` }
          });
          this.attendanceData = response.data || [];
        } catch (e) { console.error(e); }
    },

    async fetchBranchPerformance() {
      const today = moment().format('YYYY-MM-DD');
      const token = localStorage.getItem("accessToken");
      const companyId = localStorage.getItem('companyId');

      try {
        let qryParams;
        if(this.userRole==2){
          qryParams= { company_id: companyId,
            type: 'performance_by_branch',
            start_date: today,
            end_date: today , branch_id:this.branchId}
        }else{
          qryParams= { company_id: companyId,
            type: 'performance_by_branch',
            start_date: today,
            end_date: today }
        }
        const response = await axios.get(`${this.$store.state.apiURL}reports/tasks`, {
          params: qryParams,
          headers: { 'Authorization': `Bearer ${token}` }
        });

        // Guardamos la respuesta en una variable nueva
        this.branchPerformanceData = response.data || [];
      } catch (err) {
        console.error("Error en reporte sucursales:", err);
      }
    },
    initializeMap() {
      // markRaw es vital para evitar el error '_latLngToNewLayerPoint' de Leaflet en Vue 3
      this.map = markRaw(L.map('map-container').setView([13.43, -88.17], 8));
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
    },

    formatTime(dt) {
      if (!dt || dt.includes('00:00:00')) return '--:--';
      return moment(dt).format('hh:mm A');
    },
    formatDateTime(dt) {
      if (!dt) return '---';
      return moment(dt).format('hh:mm A');
    },
    async handlePrint() {

      const reportData = {
        branchTotals: this.branchTotals,
        branchPerformanceData: this.branchPerformanceData,
        grandTotal: this.grandTotal
      };

      try {
        // LLAMADA PURA: Sin pasar imágenes de gráficos
        await useDashboardPDF(reportData, this.companyConfig);
      } catch (error) {
        console.error("Error al imprimir:", error);
      }
    }
  },
  mounted() {
    try{
      this.initializeMap();
      this.fetchDashboardData();
      this.fetchAttendanceReport();
      this.fetchBranchPerformance();
      this.polling = setInterval(() => {
        this.fetchDashboardData();
        this.fetchAttendanceReport();
        this.fetchBranchPerformance();
      }, 10000);
    }catch{
      this.$router.replace('/signin')
    }

  },
  beforeUnmount() {
    clearInterval(this.polling);
    if (this.map) {
      this.map.remove();
    }
  }
};
</script>